export default {
    cognito: {
        COGNITO_REGION: 'us-west-2',
        USER_POOL_ID: 'us-west-2_IaOv3VaDd',
        APP_CLIENT_ID: '3jj0sgn2oqspp587bs0qhba88p',
        authType: 'AMAZON_COGNITO_USER_POOLS'
    }
}